import React from "react";

const Bill = ({ order, onDownload }) => {
  const generateOrderId = () => {
    return `ARN${Date.now().toString().slice(-8)}`;
  };

  const orderId = order.orderId || order.id || generateOrderId();
  const invoiceNumber = `INV-${orderId.slice(0, 8)}`;
  const currentDate = new Date().toLocaleDateString("en-IN", { 
    year: "numeric", 
    month: "long", 
    day: "numeric" 
  });
  const orderDate = order.createdAt ? new Date(order.createdAt).toLocaleDateString("en-IN", {
    year: "numeric", 
    month: "long", 
    day: "numeric" 
  }) : currentDate;

  const toNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const subtotal = order.subtotal || order.items?.reduce((sum, item) => {
    const price = toNumber(item.price);
    const qty = toNumber(item.qty || item.quantity) || 1;
    return sum + (price * qty);
  }, 0) || 0;

  const gst = order.gst || Math.round(subtotal * 0.18);
  const grandTotal = order.total || (subtotal + gst);

  return (
    <>
      <style jsx>{`
        @media print {
          * { 
            box-sizing: border-box;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          html, body { 
            margin: 0; 
            padding: 0; 
            width: 100%;
            height: 100%;
          }
          body * { visibility: hidden; }
          #bill-content, #bill-content * { visibility: visible; }
          #bill-content { 
            position: absolute; 
            left: 0; 
            top: 0; 
            width: 100%; 
            height: auto;
            margin: 0;
            padding: 10mm;
            font-size: 8px;
            transform: scale(0.95);
            transform-origin: top left;
          }
          .d-print-none, .btn, button { display: none !important; visibility: hidden !important; }
          @page { 
            size: A4 portrait; 
            margin: 5mm;
          }
        }
        @media screen {
          .d-print-none { display: block !important; }
        }
        .bill-container {
          font-family: 'Arial', 'Helvetica', sans-serif;
          line-height: 1.2;
        }
      `}</style>
      
      <div id="bill-content" className="bill-container" style={{ 
        width: "190mm", 
        minHeight: "auto",
        margin: "0 auto",
        padding: "10mm",
        backgroundColor: "white",
        fontSize: "9px",
        color: "#333",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)"
      }}>
        
        {/* Header */}
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "flex-start",
          marginBottom: "20px",
          paddingBottom: "15px",
          borderBottom: "3px solid #667eea"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <img
              src="/L.png"
              alt="AarnaSignatures Logo"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "8px",
                objectFit: "contain"
              }}
            />
            <div>
              <h1 style={{ 
                margin: "0 0 8px 0", 
                color: "#667eea", 
                fontSize: "28px", 
                fontWeight: "bold",
                letterSpacing: "1px"
              }}>
                AarnaSignatures
              </h1>
              <p style={{ margin: "0 0 4px 0", fontSize: "11px", color: "#666" }}>
                Premium Perfumes & Luxury Fragrances
              </p>
              <p style={{ margin: "0", fontSize: "10px", color: "#888" }}>
                📧 info@aarnasignatures.com | 📱 +91-XXXXXXXXXX
              </p>
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <h2 style={{ 
              margin: "0 0 8px 0", 
              color: "#667eea", 
              fontSize: "22px", 
              fontWeight: "bold"
            }}>
              TAX INVOICE
            </h2>
            <div style={{ fontSize: "10px", color: "#666" }}>
              <p style={{ margin: "2px 0" }}>Invoice No: <strong>{invoiceNumber}</strong></p>
              <p style={{ margin: "2px 0" }}>Date: <strong>{currentDate}</strong></p>
              <p style={{ margin: "2px 0" }}>GSTIN: <strong>07AABCU9603R1ZX</strong></p>
            </div>
          </div>
        </div>

        {/* Customer & Order Details */}
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "1fr 1fr", 
          gap: "25px", 
          marginBottom: "20px" 
        }}>
          <div>
            <h4 style={{ 
              margin: "0 0 10px 0", 
              color: "#2f0f0c", 
              fontSize: "12px", 
              fontWeight: "bold",
              textTransform: "uppercase",
              borderBottom: "1px solid #ddd",
              paddingBottom: "4px"
            }}>
              BILL TO
            </h4>
            <div style={{ fontSize: "11px", lineHeight: "1.5" }}>
              <p style={{ margin: "0 0 3px 0", fontWeight: "bold", fontSize: "12px" }}>
                {order.name || "Customer Name"}
              </p>
              <p style={{ margin: "0 0 2px 0" }}>
                {order.address || "Address Line 1"}
              </p>
              <p style={{ margin: "0 0 2px 0" }}>
                {order.city || "City"}, {order.state || "State"} - {order.pincode || "000000"}
              </p>
              <p style={{ margin: "0 0 2px 0" }}>
                📧 {order.email || "customer@email.com"}
              </p>
              <p style={{ margin: "0" }}>
                📱 {order.phone || "+91 XXXXXXXXXX"}
              </p>
            </div>
          </div>
          
          <div>
            <h4 style={{ 
              margin: "0 0 10px 0", 
              color: "#2f0f0c", 
              fontSize: "12px", 
              fontWeight: "bold",
              textTransform: "uppercase",
              borderBottom: "1px solid #ddd",
              paddingBottom: "4px"
            }}>
              ORDER DETAILS
            </h4>
            <div style={{ fontSize: "11px", lineHeight: "1.5" }}>
              <p style={{ margin: "0 0 3px 0" }}>
                <strong>Order ID:</strong> {orderId.slice(0, 12)}
              </p>
              <p style={{ margin: "0 0 3px 0" }}>
                <strong>Order Date:</strong> {orderDate}
              </p>
              <p style={{ margin: "0 0 3px 0" }}>
                <strong>Payment ID:</strong> {order.paymentId?.slice(0, 15) || "N/A"}
              </p>
              <p style={{ margin: "0 0 3px 0" }}>
                <strong>Payment Method:</strong> Online Payment
              </p>
              <p style={{ margin: "0" }}>
                <strong>Status:</strong> <span style={{ color: "#27ae60", fontWeight: "bold" }}>✓ PAID</span>
              </p>
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div style={{ marginBottom: "20px", flex: "1" }}>
          <table style={{ 
            width: "100%", 
            borderCollapse: "collapse",
            border: "1px solid #ddd"
          }}>
            <thead>
              <tr style={{ backgroundColor: "#f8f9fa" }}>
                <th style={{ 
                  padding: "8px 10px", 
                  textAlign: "left", 
                  fontSize: "11px", 
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  color: "#2f0f0c"
                }}>S.No</th>
                <th style={{ 
                  padding: "8px 10px", 
                  textAlign: "left", 
                  fontSize: "11px", 
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  color: "#2f0f0c"
                }}>Product Description</th>
                <th style={{ 
                  padding: "8px 10px", 
                  textAlign: "center", 
                  fontSize: "11px", 
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  color: "#2f0f0c"
                }}>Qty</th>
                <th style={{ 
                  padding: "8px 10px", 
                  textAlign: "right", 
                  fontSize: "11px", 
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  color: "#2f0f0c"
                }}>Rate (₹)</th>
                <th style={{ 
                  padding: "8px 10px", 
                  textAlign: "right", 
                  fontSize: "11px", 
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  color: "#2f0f0c"
                }}>Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              {order.items && order.items.length > 0 ? (
                order.items.map((item, index) => {
                  const price = toNumber(item.price);
                  const qty = toNumber(item.qty || item.quantity) || 1;
                  const lineTotal = price * qty;
                  
                  return (
                    <tr key={index}>
                      <td style={{ 
                        padding: "8px 10px", 
                        fontSize: "10px",
                        border: "1px solid #ddd",
                        textAlign: "center"
                      }}>{index + 1}</td>
                      <td style={{ 
                        padding: "8px 10px", 
                        fontSize: "10px",
                        border: "1px solid #ddd"
                      }}>
                        <strong>{item.name}</strong>
                        {item.description && (
                          <div style={{ color: "#666", fontSize: "9px", marginTop: "2px" }}>
                            {item.description}
                          </div>
                        )}
                      </td>
                      <td style={{ 
                        padding: "8px 10px", 
                        textAlign: "center", 
                        fontSize: "10px",
                        border: "1px solid #ddd"
                      }}>{qty}</td>
                      <td style={{ 
                        padding: "8px 10px", 
                        textAlign: "right", 
                        fontSize: "10px",
                        border: "1px solid #ddd"
                      }}>{price.toFixed(2)}</td>
                      <td style={{ 
                        padding: "8px 10px", 
                        textAlign: "right", 
                        fontSize: "10px",
                        border: "1px solid #ddd",
                        fontWeight: "bold"
                      }}>{lineTotal.toFixed(2)}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" style={{ 
                    padding: "15px", 
                    textAlign: "center", 
                    color: "#999", 
                    fontSize: "10px",
                    border: "1px solid #ddd"
                  }}>
                    No items found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Totals Section */}
        <div style={{ 
          display: "flex", 
          justifyContent: "flex-end", 
          marginBottom: "20px" 
        }}>
          <div style={{ width: "250px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ 
                    padding: "6px 10px", 
                    fontSize: "11px",
                    border: "1px solid #ddd",
                    backgroundColor: "#f8f9fa"
                  }}>Subtotal:</td>
                  <td style={{ 
                    padding: "6px 10px", 
                    textAlign: "right", 
                    fontSize: "11px",
                    border: "1px solid #ddd",
                    backgroundColor: "#f8f9fa"
                  }}>₹{subtotal.toFixed(2)}</td>
                </tr>
                <tr>
                  <td style={{ 
                    padding: "6px 10px", 
                    fontSize: "11px",
                    border: "1px solid #ddd"
                  }}>GST (18%):</td>
                  <td style={{ 
                    padding: "6px 10px", 
                    textAlign: "right", 
                    fontSize: "11px",
                    border: "1px solid #ddd"
                  }}>₹{gst.toFixed(2)}</td>
                </tr>
                <tr>
                  <td style={{ 
                    padding: "6px 10px", 
                    fontSize: "11px",
                    border: "1px solid #ddd"
                  }}>Delivery:</td>
                  <td style={{ 
                    padding: "6px 10px", 
                    textAlign: "right", 
                    fontSize: "11px",
                    border: "1px solid #ddd",
                    color: "#27ae60",
                    fontWeight: "bold"
                  }}>FREE</td>
                </tr>
                <tr>
                  <td style={{ 
                    padding: "6px 10px", 
                    fontSize: "11px",
                    border: "1px solid #ddd"
                  }}>Packaging:</td>
                  <td style={{ 
                    padding: "6px 10px", 
                    textAlign: "right", 
                    fontSize: "11px",
                    border: "1px solid #ddd",
                    color: "#27ae60",
                    fontWeight: "bold"
                  }}>FREE</td>
                </tr>
                <tr>
                  <td style={{ 
                    padding: "8px 10px", 
                    fontSize: "12px",
                    border: "2px solid #667eea",
                    backgroundColor: "#667eea",
                    color: "white",
                    fontWeight: "bold"
                  }}>TOTAL AMOUNT:</td>
                  <td style={{ 
                    padding: "8px 10px", 
                    textAlign: "right", 
                    fontSize: "12px",
                    border: "2px solid #667eea",
                    backgroundColor: "#667eea",
                    color: "white",
                    fontWeight: "bold"
                  }}>₹{grandTotal.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Amount in Words */}
        <div style={{ 
          backgroundColor: "#f8f9fa", 
          padding: "10px", 
          borderRadius: "4px", 
          marginBottom: "15px",
          border: "1px solid #ddd"
        }}>
          <p style={{ margin: "0", fontSize: "10px", color: "#333" }}>
            <strong>Amount in Words:</strong> {/* You can add number to words conversion here */}
            Rupees {Math.floor(grandTotal)} and {Math.round((grandTotal % 1) * 100)} Paise Only
          </p>
        </div>

        {/* Terms & Conditions */}
        <div style={{ 
          borderTop: "2px solid #2f0f0c", 
          paddingTop: "10px",
          marginTop: "auto"
        }}>
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "1fr 1fr", 
            gap: "20px",
            fontSize: "9px",
            color: "#666"
          }}>
            <div>
              <h5 style={{ margin: "0 0 5px 0", fontSize: "10px", color: "#2f0f0c" }}>Terms & Conditions:</h5>
              <ul style={{ margin: "0", paddingLeft: "12px" }}>
                <li>All sales are final. No returns or exchanges.</li>
                <li>Goods once sold will not be taken back.</li>
                <li>Subject to local jurisdiction only.</li>
              </ul>
            </div>
            <div style={{ textAlign: "right" }}>
              <p style={{ margin: "0 0 15px 0", fontSize: "10px" }}>For AarnaSignatures</p>
              <div style={{ 
                borderTop: "1px solid #333", 
                paddingTop: "5px", 
                fontSize: "9px",
                fontWeight: "bold"
              }}>
                Authorized Signatory
              </div>
            </div>
          </div>
          
          <div style={{ 
            textAlign: "center", 
            marginTop: "10px", 
            paddingTop: "8px", 
            borderTop: "1px solid #ddd",
            fontSize: "8px",
            color: "#999"
          }}>
            This is a computer generated invoice and does not require physical signature.
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ textAlign: "center", marginTop: "15px" }} className="d-print-none">
          <button 
            className="btn btn-primary me-3 px-4 py-2"
            onClick={onDownload}
            style={{ fontSize: "12px", fontWeight: "600" }}
          >
            📥 Download PDF
          </button>
          <button 
            className="btn btn-outline-primary px-4 py-2"
            onClick={() => window.print()}
            style={{ fontSize: "12px", fontWeight: "600" }}
          >
            🖨️ Print Invoice
          </button>
        </div>

      </div>
    </>
  );
};

export default Bill;